export enum getCycles {
  Request = 'GET_CYCLES_REQUEST',
  Success = 'GET_CYCLES_SUCCESS',
  Failed = 'GET_CYCLES_FAILED',
}

export const RESET_CYCLES = 'RESET_CYCLES';
